import 'vuetify/styles';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import { VFileUpload } from 'vuetify/labs/VFileUpload';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import DateFnsAdapter from '@date-io/date-fns';
import { cs, de, enUS as en, fr, pl } from 'date-fns/locale';

const wtgTheme: ThemeDefinition = {
  dark: false,
  colors: {
    'on-surface': '#585858',
    primary: '#db0d15',
    error: '#db0d15',
  },
};

export const vuetify = createVuetify({
  components: {
    VFileUpload,
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VSelect: {
      variant: 'outlined',
      density: 'compact',
      hideDetails: true,
      menuProps: {
        offset: 8,
      },
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'compact',
    },
    VCombobox: {
      variant: 'outlined',
      density: 'compact',
    },
    VTextField: {
      variant: 'outlined',
      density: 'compact',
      hideSpinButtons: true,
    },
    VTextarea: {
      variant: 'outlined',
      density: 'compact',
    },
    VNumberInput: {
      variant: 'outlined',
      density: 'compact',
      controlVariant: 'hidden',
    },
  },
  theme: {
    defaultTheme: 'wtgTheme',
    themes: {
      wtgTheme,
    },
  },
  date: {
    adapter: DateFnsAdapter,
    locale: {
      de,
      en,
      fr,
      cs,
      pl,
    },
  },
});
